export default () => {
  const heroImage = document.querySelector('.hero');

  if (heroImage.classList.contains('hero--image')) {
    const imageOverlay = document.querySelector('.hero__image-overlay');
    const imageHolder = document.querySelector('.hero__image-holder');

    if (imageOverlay) {
      const adjustOverlayLeft = () => {
        const imageHolder = document.querySelector('.hero__image-holder');
        const imageOverlayLeft = (imageOverlay.offsetLeft - 2) + (
          imageHolder.getBoundingClientRect().left - imageOverlay.getBoundingClientRect().left
        );

        imageOverlay.style.left = `${imageOverlayLeft}px`;

        console.log('resize');
      };

      adjustOverlayLeft();
      window.addEventListener('resize', adjustOverlayLeft);
    }
  }
}
